import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m9.218 19.332 3.597 1.207V7.47c0-.455.307-1.001.672-1.001.465 0 .759.633.759 1.001v4.927c.297.174.993.52 1.4.52h.032c.556.002 2.494.006 2.494-2.948 0-3.013-1.59-4.149-2.916-4.583l-6.038-1.89v15.835Zm-1-.905v-1.735c-.839.312-1.606.564-2.079.638-.89.138-1.855.038-1.735-.469.103-.432 2.31-1.201 3.814-1.678V13.21c-2.852.89-7.213 2.396-7.213 3.401 0 1.42 3.337 1.847 4.118 1.894.457.028 1.724.072 3.095-.077Zm5.597 1.82c3.325-1.108 9.178-3.293 9.178-4.251 0-1.254-3.375-2.072-5.491-1.988-1.083.043-2.426.318-3.687.662v1.974a92 92 0 0 1 3.829-1.31c.686-.209 1.479-.169 1.846 0 .568.26.355.567-.829 1.04-.706.283-2.993 1.128-4.846 1.807z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandGamingPlaystation = { render };
export {
  brandGamingPlaystation as default,
  render
};
//# sourceMappingURL=brand-gaming-playstation.svg.js.map
